import { useEffect, useState } from "react";
const getTrackChangesStatus = async ()=>{
    let isTrackingStatus = false;
    await Word.run(async (context)=>{
        const document = context.document;
        document.load("changeTrackingMode");
        await context.sync();
        if (document.changeTrackingMode === Word.ChangeTrackingMode.trackMineOnly || document.changeTrackingMode === Word.ChangeTrackingMode.trackAll) {
            isTrackingStatus = true;
        }
    });
    return isTrackingStatus;
};
export const useTrackChangesStatus = ()=>{
    const [isTrackChangesEnabled, setTrackChangesEnabled] = useState(true);
    useEffect(()=>{
        const fetchStatus = async ()=>{
            const isTracking = await getTrackChangesStatus();
            setTrackChangesEnabled(isTracking);
        };
        fetchStatus();
        const handleWindowFocus = ()=>fetchStatus();
        window.addEventListener("focus", handleWindowFocus);
        return ()=>{
            window.removeEventListener("focus", handleWindowFocus);
        };
    }, []);
    return isTrackChangesEnabled;
};
